import type { DeleteKanbanBoardItemPayload, KanbanContext } from '@rhythmic/types'
import { DeleteKanbanBoardItemSchema, KanbanContextSchema } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'

import { getBoardItemsCollection } from '../getCollections'

const logger = useRhythmicLogger('useKanbanBoardContext.deleteBoardItem')

function validateParams(payload: DeleteKanbanBoardItemPayload, context: KanbanContext | undefined) {
  if (!context) throw new Error('Kanban board context is not ready: missing context for deleting a board item')

  logger.debug('Validating parameters for handleDeleteBoardItem', {
    payload,
    context,
  })
  const parsedPayload = DeleteKanbanBoardItemSchema.parse(payload)
  const parsedContext = KanbanContextSchema.parse(context)

  return {
    context: parsedContext,
    payload: parsedPayload,
  }
}

export default function handleDeleteBoardItem(
  payload: DeleteKanbanBoardItemPayload,
  context: KanbanContext | undefined,
): Transaction {
  logger.debug('handleDeleteBoardItem called', { payload, context })
  const { context: validatedContext, payload: validatedPayload } = validateParams(payload, context)
  const boardItemsCollection = getBoardItemsCollection(validatedContext.boardId)

  logger.debug('Deleting board item from collection', {
    boardId: validatedContext.boardId,
    boardItemId: validatedPayload.boardItemId,
  })

  // Assuming collection.delete handles the API call based on configuration
  const deleteTx = boardItemsCollection.delete(validatedPayload.boardItemId)

  return deleteTx
}
